import {
  GET_STORES_URL,
  GET_STORE_URL,
  CREATE_STORE_URL,
  UPDATE_STORE_URL,
} from "../../config/Url";
import { BazaarHttpClient } from "../http/BazaarHttpClient";
import { IcreateUserPayload, IPartnerChannel } from "../../interfaces/Index";
import { StoreStatus } from "./../../config/constants";

export class StoreSource {
  private key: string = "{store_id}";

  public constructor(private client: BazaarHttpClient) {}

  public createStore(store: StoreAddUpdateDto) {
    return this.client.post(CREATE_STORE_URL, store);
  }

  public updateStore(id: string, store: StoreAddUpdateDto) {
    const url = UPDATE_STORE_URL.replace(this.key, id);
    return this.client.put(url, store);
  }

  public getStores(): Promise<Array<StoreInfoDto>> {
    return this.client.get(GET_STORES_URL);
  }

  public getStore(id: string): Promise<StoreInfoDto> {
    const url = GET_STORE_URL.replace(this.key, id);
    return this.client.get(url);
  }
}

export default new StoreSource(new BazaarHttpClient());
export interface StoreAddress {
  id?: string;
  address: string;
  latitude: number;
  longitude: number;
  zoneId: string
}

export interface StoreUser {
  id?: string;
  userId: string;
}

export class StoreAddUpdateDto {
  public constructor(
    public id: string,
    public name: string,
    public ownerName: string,
    public phoneNumber: string,
    public status: StoreStatus,
    public user: StoreUser,
    public address: StoreAddress,
    public storeType: string,
    public incomeTaxStatus: string,
    public registrationType: string,
    public partners: Array<IPartnerChannel>
  ) {}

  public static fromCreateDto(
    id: string,
    dto: IcreateUserPayload,
    userId: string
  ) {
    const storeUser: StoreUser = {
      id,
      userId,
    };

    const storeAddress: StoreAddress = {
      id,
      address: String(dto.address),
      latitude: Number(dto.latitude),
      longitude: Number(dto.longitude),
      zoneId: String(dto.zoneId)
    };

    return new StoreAddUpdateDto(
      id,
      String(dto.storeName),
      String(dto.name),
      String(dto.phone).trim(),
      StoreStatus.PENDING,
      storeUser,
      storeAddress,
      String(dto.storeType),
      String(dto.incomeTaxStatus),
      String(dto.registrationType),
      dto.partners as Array<IPartnerChannel>
    );
  }

  public static fromUpdateDto(
    id: string,
    dto: any,
    userId: string
  ): StoreAddUpdateDto {
    const storeUser: StoreUser = {
      id,
      userId,
    };

    const latitude = Number(dto.coordinates.latitude);
    const longitude = Number(dto.coordinates.longitude);
    const zoneId = String(dto.addressDetails.zoneId)

    const storeAddress: StoreAddress = {
      id,
      address: String(dto.addressDetails.address),
      latitude: latitude,
      longitude: longitude,
      zoneId: zoneId
    };
    
    // default
    let storeStatus

    switch(dto.status){
      case "ACTIVE":
        storeStatus = StoreStatus.ACTIVE
        break;
      case "SUSPENDED":
        storeStatus = StoreStatus.SUSPENDED
        break;
      case "UNVERIFIED":
        storeStatus = StoreStatus.UNVERIFIED
        break;
      case "PENDING":
        storeStatus = StoreStatus.PENDING
        break;
      default:
          storeStatus = StoreStatus.INACTIVE
    }

    return new StoreAddUpdateDto(
      id,
      String(dto.addressDetails.company),
      String(dto.name),
      String(dto.phone).trim(),
      storeStatus,
      storeUser,
      storeAddress,
      String(dto.storeType),
      String(dto.incomeTaxStatus),
      String(dto.registrationType),
      dto.partners as Array<IPartnerChannel>
    );
  }
}

export class StoreInfoDto {
  public constructor(
    public name: string,
    public ownerName: string,
    public phone: string,
    public status: StoreStatus,
    public storeType: string,
    public user: StoreUser,
    public address: StoreAddress,
  ) {}
}
